import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import ReturnAdd from "./ReturnAdd";
import ReturnEdit from "./ReturnEdit";
import log from "../lib/log";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "./CenterSelect";
import pr from "../lib/pr";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import get_token from "../lib/get_token";
import Switch from '@mui/material/Switch';

function ReturnEditDetail(props) {
    const { seq, login } = props;
    const [rows, setRows] = useState([]);
    const [check, setCheck] = useState([]);
    const onChangeState = async (id, checked) => {        
        const idx = rows.findIndex(el=>el.id === id);       
        setRows(state=>{
            let newState = state;          
            newState[idx].is_return = checked?'Y':'';       
            return [...newState];
        });

        // update         
        let result = await axios.post(configState.api + '/gympass_admin/return_detail_edit',{
            mcd : login.mcd,
            level : login.level,
            token : get_token(),
            seq: rows[idx].id,
            is_return : checked?'Y':''
        });        
        console.log(result.data);
    }
    const columns = [
        { field: "id", headerName: "id", hide: true },
        {
            field: "is_return", headerName: "환불", width: 90, align: "center",
            renderCell: (params) => {
                const checked = params.row.is_return==='Y'?true:false;
                return <Switch checked={checked} onChange={(e)=>onChangeState(params.id, e.target.checked)}></Switch>;
                return 0;
            },
        },
        { field: "cpname", headerName: "쿠폰명", width: 140, align: "center" },
        { field: "class_date", headerName: "수업일", width: 140, align: "center" },
        { field: "class_hour", headerName: "수업시간", width: 90, align: "center" },
        { field: "tname", headerName: "강사명", width: 90, align: "center" },
        { field: "cname", headerName: "센터명", width: 180, align: "center" },
    ];

    // 데이타
    const load_data = async () => {
        let result = await axios.post(configState.api + "/gympass_admin/return_detail", {
            token: get_token(),
            cid: login.cid,
            level: login.level,
            mcd: login.mcd,
            seq: seq,
        });
        if (result.data.success === 1) {
            setRows(result.data.rows);
        } else {
            Swal.fire(result.data.msg);
            return;
        }
    };

    // 리스트
    useEffect(() => {
        load_data();
    }, []);

    return (
        <Box sx={{ width: 550, height: 500 }}>
            <DataGrid
                rows={rows}
                columns={columns}
                pageSize={10}
                rowsPerPageOptions={[5]}
                checkboxSelection={false}
            />
        </Box>);

}

export default ReturnEditDetail;
